/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { QaRtSystemTemplateContainerDto } from './QaRtSystemTemplateContainerDto';
import {
    QaRtSystemTemplateContainerDtoFromJSON,
    QaRtSystemTemplateContainerDtoFromJSONTyped,
    QaRtSystemTemplateContainerDtoToJSON,
} from './QaRtSystemTemplateContainerDto';

/**
 * 
 * @export
 * @interface QaRtSystemTemplateDto
 */
export interface QaRtSystemTemplateDto {
    /**
     * 
     * @type {Array<QaRtSystemTemplateContainerDto>}
     * @memberof QaRtSystemTemplateDto
     */
    containers?: Array<QaRtSystemTemplateContainerDto> | null;
    /**
     * 
     * @type {string}
     * @memberof QaRtSystemTemplateDto
     */
    $type?: QaRtSystemTemplateDtoTypeEnum;
}


/**
 * @export
 */
export const QaRtSystemTemplateDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoQaRtSystemTemplateDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.QaRtSystemTemplateDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type QaRtSystemTemplateDtoTypeEnum = typeof QaRtSystemTemplateDtoTypeEnum[keyof typeof QaRtSystemTemplateDtoTypeEnum];


/**
 * Check if a given object implements the QaRtSystemTemplateDto interface.
 */
export function instanceOfQaRtSystemTemplateDto(value?: unknown): value is QaRtSystemTemplateDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(QaRtSystemTemplateDtoTypeEnum)[0];
}

export function QaRtSystemTemplateDtoFromJSON(json: any): QaRtSystemTemplateDto {
    return QaRtSystemTemplateDtoFromJSONTyped(json, false);
}

export function QaRtSystemTemplateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QaRtSystemTemplateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'containers': !exists(json, 'containers') ? undefined : (json['containers'] === null ? null : (json['containers'] as Array<any>).map(QaRtSystemTemplateContainerDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function QaRtSystemTemplateDtoToJSON(value?: QaRtSystemTemplateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'containers': value.containers === undefined ? undefined : (value.containers === null ? null : (value.containers as Array<any>).map(QaRtSystemTemplateContainerDtoToJSON)),
        '$type': value.$type,
    });
}

